import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { AccountService } from '../account.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged, tap, filter, flatMap, switchMap, catchError } from 'rxjs/operators';
import { Account } from '../models/account';
import { Headset } from '../models/headset';

@Component({
  selector: 'app-search-account',
  templateUrl: './search-account.component.html',
  styleUrls: ['./search-account.component.css'],
})
export class SearchAccountComponent implements OnInit {

  @Output() accSelected: EventEmitter<any> = new EventEmitter<any>();

  formGroup: FormGroup;
  // accountsList: string[] = [];
  accountsList: Account[] = [];
  loading = false;

  selectedAccount: Account;
  headsets: Headset[] = [];

  constructor(
    private _fb: FormBuilder,
    private _accountService: AccountService
  ) { }

  ngOnInit() {
    this.createForm();
    this.setupAccountFilter();
  }

  createForm() {
    this.formGroup = this._fb.group({
      account: [''],
    });
  }

  setupAccountFilter() {
    const control = this.formGroup.get('account');
    control.valueChanges
      .pipe(
        tap(() => this.accountsList = []),
        debounceTime(250),
        distinctUntilChanged(),
        filter(Boolean), // gets rid of blanks
        flatMap((val: string): any => {
          this.loading = true;
          return this._accountService.searchAccount(val);
        }),
      )
      .subscribe((data: any) => {
        this.loading = false;
        this.accountsList = data;
      });
  }

  displayFnAccount(val: any) {
    return val.email;
  }

  selectAccount(option) {
    this.formGroup.get('account').setValue('');
    this.accSelected.emit(option.option.value);
  }

}



// WEBPACK FOOTER //
// ./src/app/search-account/search-account.component.ts